// mapconfig.js

export const apiKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;
export const mapId = "b056103bec2bf195";

export const locationsDiscovered = ["loc1", "loc2"];

export const markerData = [
  { id: "loc01", lat: 59.325, lng: 18.07083, title: "Stortorget" },
  { id: "loc02", lat: 59.3253, lng: 18.0708, title: "Nobel Museum" },
  { id: "loc03", lat: 59.324167, lng: 18.071667, title: "Tyska Kyrkan" },
  { id: "loc04", lat: 59.325278, lng: 18.073722, title: "Köpmanbrinken" },
  { id: "loc05", lat: 59.32306, lng: 18.07279, title: "Mårten Trotzigs Gränd" },
  { id: "loc06", lat: 59.32694, lng: 18.07167, title: "The Royal Palace" },
  { id: "loc07", lat: 59.32468, lng: 18.06458, title: "Riddarholmen Church" },
  { id: "loc08", lat: 59.324724, lng: 18.070018, title: "Runestone at Prästgatan" },
  { id: "loc09", lat: 59.32583, lng: 18.07056, title: "Storkyrkan" },
  { id: "loc10", lat: 59.32548, lng: 18.07236, title: "Iron Boy" },
];

export const center = { lat: 59.3251, lng: 18.0718 }; // Gamla Stan

export const mapLibraries = ["marker"];
